
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.8 13.795c0-.66.535-1.195 1.197-1.195h8.406c.661 0 1.197.536 1.197 1.195v6.61c0 .66-.536 1.195-1.197 1.195h-8.406a1.197 1.197 0 01-1.197-1.195v-6.61zm1.2.306v5.998c0 .163.134.301.299.301H20.1a.299.299 0 00.299-.3v-6c0-.162-.134-.3-.3-.3H12.3a.299.299 0 00-.3.3zm-9.6-.306c0-.66.541-1.195 1.205-1.195h4.79A1.2 1.2 0 019.6 13.795v6.61c0 .66-.541 1.195-1.205 1.195h-4.79A1.2 1.2 0 012.4 20.405v-6.61zm1.2.306v5.998c0 .163.134.301.3.301h4.2c.161 0 .3-.135.3-.3v-6c0-.162-.135-.3-.3-.3H3.9c-.162 0-.3.135-.3.3zM15 3.595c0-.66.54-1.195 1.195-1.195h4.21c.66 0 1.195.536 1.195 1.195v6.61c0 .66-.54 1.195-1.195 1.195h-4.21c-.66 0-1.195-.536-1.195-1.195v-6.61zm1.2.306v5.998c0 .163.135.301.302.301h3.596a.304.304 0 00.302-.3v-6c0-.162-.135-.3-.302-.3h-3.596a.304.304 0 00-.302.3zM2.4 3.595c0-.66.534-1.195 1.198-1.195h9.003c.662 0 1.199.536 1.199 1.195v6.61c0 .66-.535 1.195-1.199 1.195H3.598A1.197 1.197 0 012.4 10.205v-6.61zm1.2.306v5.998c0 .163.134.301.3.301h8.4a.3.3 0 00.3-.3v-6c0-.162-.134-.3-.3-.3H3.9a.3.3 0 00-.3.3z","fill":"currentColor"}})])
          )
        }
      }
    